module.exports = __webpack_public_path__ + "media/images/static/top/local/hero_copy-705f3f51af8da0fd08c6e0fb8021af95.png";